export const GET_OVERVIEW_DATA = 'GET_OVERVIEW_DATA'

export const getOverviewData = () => {
	return {
		type: GET_OVERVIEW_DATA,
	}
}
